import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useParentsInfoChartsDataContext } from './hooks/useParentsInfoChartsDataContext';

export const MotherMaritalStatus = () => {
    const { chartData } = useParentsInfoChartsDataContext();


    return (
        <SimpleBars
            title={'Estado Civil da Mãe'}
            horizontal={false}
            subtitles={chartData?.motherMaritalStatus?.map((item) => item.description)}
            values={chartData?.motherMaritalStatus?.map((item) => item.total  ||  0)}
        />
    );
};
